export const SERVICES = [
  { id: "general-opd", title: "General OPD", tag: "Everyday care", items: ["Fever, cold & cough", "Headache", "Acidity", "Minor infections"], icon: "Stethoscope" },
  { id: "chronic-care", title: "Chronic Care", tag: "Long-term", items: ["Diabetes", "Hypertension", "Thyroid disorders"], icon: "Activity" },
  { id: "preventive-health", title: "Preventive Health", tag: "Screening", items: ["Health checks", "BP & sugar", "BMI", "Report review"], icon: "ShieldCheck" },
  { id: "lifestyle-counselling", title: "Lifestyle Counselling", tag: "Habits", items: ["Stress", "Sleep", "Diet", "Healthy habits"], icon: "Leaf" },
  { id: "womens-health", title: "Women's Health", tag: "Every life stage", items: ["Menstrual health", "PCOS", "Pre-conception care", "Menopause care"], icon: "Flower2" },
  { id: "skin-hair-care", title: "Skin & Hair Care", tag: "Dermal", items: ["Acne", "Pigmentation", "Hair fall", "Dandruff"], icon: "Sparkles" },
  { id: "basic-procedures", title: "Basic Procedures", tag: "In-clinic", items: ["Injections", "Dressing", "Nebulisation", "BP & sugar checks"], icon: "Syringe" },
];

export const NEEDS = [
  { id: "lifestyle-disorders", need: "Lifestyle Disorders", answer: "Structured monitoring & clinical guidance" },
  { id: "preventive-healthcare", need: "Preventive Healthcare", answer: "Periodic health assessment & screening" },
  { id: "urban-work", need: "Urban Work Patterns", answer: "Practical lifestyle & routine counselling" },
  { id: "chronic-conditions", need: "Chronic Conditions", answer: "Ongoing clinical care management" },
  { id: "wellness-needs", need: "Wellness Needs", answer: "Personalised health programmes" },
  { id: "service-fragmentation", need: "Service Fragmentation", answer: "Integrated family healthcare approach" },
];

export const STEPS = [
  { n: "01", name: "Assessment", desc: "Understand the presenting concern and your health background." },
  { n: "02", name: "Consultation", desc: "Clinical evaluation and professional guidance." },
  { n: "03", name: "Lifestyle Review", desc: "A review of diet, sleep, activity and daily routine." },
  { n: "04", name: "Personalised Plan", desc: "Suitable care and wellness recommendations, built for you." },
  { n: "05", name: "Follow-Up", desc: "Track progress and modify guidance where required." },
];

export const PILLARS = [
  { name: "Preventive Care", desc: "BP, blood sugar, BMI, health checks & report review" },
  { name: "Chronic Care", desc: "Diabetes, hypertension & thyroid-related support" },
  { name: "Lifestyle Wellness", desc: "Sleep, diet, stress management & healthy habits" },
  { name: "Women's Health", desc: "Menstrual concerns, PCOS, pre-conception & menopause care" },
  { name: "General Healthcare", desc: "Common illnesses and routine clinical consultation" },
  { name: "Basic Clinical Support", desc: "Dressing, injections, nebulisation & basic checks" },
];

export const OBJECTIVES = [
  { name: "Integrated Care", desc: "Combine clinical consultation with lifestyle and preventive care." },
  { name: "Patient-Centric Services", desc: "Develop personalised health management programmes." },
  { name: "Service Expansion", desc: "Broaden the existing consultation-led model." },
  { name: "Digital Integration", desc: "Introduce technology-enabled health management." },
  { name: "Family Healthcare", desc: "Build services suitable for multiple household needs." },
  { name: "Scalability", desc: "Establish a structured model capable of serving a larger community." },
];

export const MARQUEE = ["General OPD", "Chronic Care", "Preventive Health", "Lifestyle Counselling", "Women's Health", "Skin & Hair Care", "Basic Procedures", "Lifestyle-first, always"];

export const CONTACT = {
  address: "C1, Meenakshi Planet City, Bhopal, MP",
  phone: "7697570008",
  email: "welconhealthconsultations@gmail.com",
  hours: "Monday to Saturday\nMorning 9:00 AM – 2:00 PM\nEvening 6:00 PM – 8:00 PM",
  doctor: "Dr. Shivangi Dixit Sharma\nMBBS\nFellowship in Family Medicine (IMA Chennai)\nFellowship in Aesthetic Medicine (ILAMED, New Delhi)",
};
